// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import deliveryDeployMng from './metaData/deliveryDeploy'
export default {
  state: deliveryDeployMng,
  actions
}
